import * as React from "react";

export type EditModeContextValue = {
  editMode: boolean;
  editingOfferingKey: string | null;
  setEditingOfferingKey: (key: string | null) => void;
  isOfferingEditing: (offeringKey: string) => boolean;
};

const EditModeContext = React.createContext<EditModeContextValue>({
  editMode: false,
  editingOfferingKey: null,
  setEditingOfferingKey: () => {},
  isOfferingEditing: () => false,
});

export const EditModeProvider = EditModeContext.Provider;

export function useEditMode(): boolean {
  return React.useContext(EditModeContext).editMode;
}

export function useEditModeState(): EditModeContextValue {
  return React.useContext(EditModeContext);
}

export function useIsOfferingEditing(offeringKey: string): boolean {
  const { isOfferingEditing } = React.useContext(EditModeContext);
  return isOfferingEditing(offeringKey);
}